import { useState } from "react";
import { IStudentGradeDetail } from "../../../../models/student/studentGradeDetail";
import { Chart } from "primereact/chart";
import { connect } from "react-redux";
import { getStudentGradeDetail } from "../../../../action/student/studentGradeDetailsActionCreator";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setStudentGradeDetail } from "../../../../store/slices/student/studentGradeSlice";
import { useNavigate } from "react-router-dom";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import ChartDataLabels from 'chartjs-plugin-datalabels';

const StudentGradeDetails = (props: IStudentGradeDetail) => {
  const { getStudentGrade, studentGrade, userInfo } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (userInfo && userInfo?.id) {
      getStudentGrade(userInfo?.id);
    }
  }, [userInfo?.id]);

  useEffect(() => {
    return () => {
      dispatch(setStudentGradeDetail([]));
    };
  }, []);

  const handleViewPage = () => {
    navigate(ROUTER_URL.STUDENT_GRADES);
  };

  const [chartData, setChartData] = useState({});

  useEffect(() => {
    if (studentGrade) {
      setChartData({
        labels: studentGrade?.map(student => student.grade),
        datasets: [
          {
            data: studentGrade?.map(student => student.percentage),
            // backgroundColor: studentGrade?.map(student => student.colorCode),
            backgroundColor : ["rgb(250, 151, 29)", "rgb(250, 115, 97)", "rgb(181, 82, 82)", "rgb(92, 126, 126)"],
            hoverOffset: 4,
          },
        ],
      });
    }
  }, [studentGrade]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '40%',
    plugins: {
      legend: {
        display: false,
        position: "left",
        labels: {
          usePointStyle: true,
          padding: 20,
        },
      },
      datalabels: {
        align: 'center',
        color: 'white',
        font: {
          weight: 'bold',
          size: 14,
        },
        formatter: (value: number) => {
          return `${value}%`;
        },
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem: any) {
            return tooltipItem.label;
          },
          title: function () {
            return "";
          },
        },
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        titleColor: "white",
        bodyColor: "white",
        displayColors: false,
        position: "average",
        caretPadding: 20,
        yAlign: "bottom",
      },
    },
    elements: {
      arc: {
        borderWidth: 2, // Controls the width of the border between segments
        borderColor: "white", // Adds a white border between segments
        borderRadius: 10, // Rounded edges for the chart segments
      },
    },
  };

  return (
    <>
      <div className="card h-100 student_metrics">
        <a onClick={handleViewPage}>
          <div className="top">
            <div className="img">
              <img src="/assets/images/icon/chart-pie.svg" alt="" />
            </div>
            <div className="desc">
              <h2>Grade Details</h2>
              <span>Grade details for the current term.</span>
            </div>
          </div>
          <div className="dtls gardedistribution">
            <div className="desc">
              <div className="legend" id="legend-container">
                <div className="legend-item">
                  <div className="legend-color" style={{ backgroundColor: "rgb(250, 151, 29)" }} ></div>
                  <span>A</span>
                </div>
                <div className="legend-item">
                  <div className="legend-color" style={{ backgroundColor: "rgb(250, 115, 97)" }}></div>
                  <span>B</span>
                </div>
                <div className="legend-item">
                  <div className="legend-color" style={{ backgroundColor: "rgb(181, 82, 82)" }}></div>
                  <span>C</span>
                </div>
                <div className="legend-item">
                  <div className="legend-color" style={{ backgroundColor: "rgb(92, 126, 126)" }}></div>
                  <span>P</span>
                </div>
              </div>


            </div>
            <div className="chartWrap-new">
              <Chart
                type="doughnut"
                data={chartData}
                options={options}
                className=""
                plugins={[ChartDataLabels]}
              />
            </div>
          </div>
        </a>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getStudentGrade: (studentId: string) => getStudentGradeDetail(studentId),
};

function mapStateToProps(state: any) {
  return {
    userInfo: state.userDetails.userProfileData,
    studentGrade: state.studentGradeDetail.gradeDetail,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentGradeDetails);
